import React, { useState } from 'react'
import { Col, Form, FormInstance, Input, Row } from 'antd'
import { itemsToBringStore } from 'state/listing/itemsToBringListing'
import { Photo } from 'types/globalTypes'
import { myStore } from 'state/store'
import UploadDocument from 'components/global/UploadDocument'
import {
  useCreateItemsToBring,
  useUpdateItemsToBring,
} from 'api/Listings/itemsToBring'

interface ItemsToBringFormProps {
  form: FormInstance
  organizationId?: string
}

const ItemsToBringForm: React.FC<ItemsToBringFormProps> = ({
  form,
  organizationId,
}) => {
  const { itemsToBringData, setAddItemsToBringModal } = itemsToBringStore(
    store => ({
      itemsToBringData: store.itemsToBringData,
      setAddItemsToBringModal: store.setAddItemsToBringModal,
    }),
  )
  const setModalBtnLoading = myStore(store => store.setModalBtnLoader)
  const [error, setError] = useState<string>('')
  const [documentIds, setDocumentIds] = useState<string[]>(
    itemsToBringData ? [itemsToBringData.iconId] : [],
  )
  const [photos] = useState<Photo[]>(
    itemsToBringData ? [itemsToBringData.icon] : [],
  )

  const formSchema = {
    name: itemsToBringData ? itemsToBringData.name : undefined,
  }

  const { mutate: createItemToBring } = useCreateItemsToBring()
  const { mutate: updateItemToBring } = useUpdateItemsToBring()

  const onFinish = (values: { name: string; color: string }) => {
    const payload = {
      ...values,
      iconId: documentIds[0],
      organizationId: organizationId,
    }
    setModalBtnLoading(true)
    if (itemsToBringData) {
      updateItemToBring(
        { itemToBringId: itemsToBringData._id, payload },
        {
          onSuccess: () => {
            setModalBtnLoading(false)
            setAddItemsToBringModal(false)
          },
          onError: () => {
            setModalBtnLoading(false)
          },
        },
      )
    } else {
      createItemToBring(payload, {
        onSuccess: () => {
          setModalBtnLoading(false)
          setAddItemsToBringModal(false)
        },
        onError: () => {
          setModalBtnLoading(false)
        },
      })
    }
  }

  return (
    <>
      <Form
        name="items-to-bring-form"
        form={form}
        initialValues={formSchema}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
      >
        <Row>
          <Col>
            <label className="custom-field-label">Add Icon</label>
          </Col>
          <Col span={12}>
            <UploadDocument
              documentIds={documentIds}
              setDocumentIds={setDocumentIds}
              multiple={true}
              docType="image/*"
              files={photos}
            />
          </Col>
          {/* {error && (
            <Col className="-mt-20px" span={24}>
              <p className="ant-form-item-explain-error">{error}</p>
            </Col>
          )} */}
        </Row>
        <Row className="-mt-10px">
          <Col span={24}>
            <label className="input-label required-input">Name</label>
            <Form.Item
              colon={false}
              name="name"
              rules={[{ required: true, message: 'Name is required' }]}
            >
              <Input placeholder="Enter Name" required name="name" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default ItemsToBringForm
